import { VisorFirebaseService } from './../../services/visor-firebase.service';
import { SigpacServiceService } from './../../services/sigpac-service.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Geometry, Point,Polygon} from 'ol/geom';
import {Style,Fill, Stroke} from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import LayerSwitcher from 'ol-layerswitcher';
import { BaseLayerOptions, GroupLayerOptions } from 'ol-layerswitcher';
import Attribution from 'ol/control/Attribution';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import { Router } from '@angular/router';
import { NbSearchService, NbToastrService } from '@nebular/theme';
import { MapQueryService } from 'app/services/map-query.service';
import Select from 'ol/interaction/Select';
import listadoProductos from '../../listados/productos.json';
@Component({
  selector: 'visor-sigpac',
  templateUrl: './visor-sigpac.component.html',
  styleUrls: ['./visor-sigpac.component.scss']
})
export class VisorSigpacComponent implements OnInit,AfterViewInit {

  config:any;
  map: Map;
  icondiario: any = {icon:'table',pack:'font-awesome'};
  feature: Feature<Geometry>;
  vectorSource: VectorSource<Geometry>;
  parcelasSource: VectorSource<Geometry>;
  featureoriginal: Feature<Geometry>;
  parcelasigpac:any;
  vtl: VectorTileLayer;
  parcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 1)',
    }),
  });


  selectedParcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 255, 120)',
    }),
  });

  loading = false;
  parcelas: any[];
  originalParcelas: any[];
  productos = listadoProductos;
  seasons = [];
  cultivos = [];
  municipios = [];
  propietarios = [];
  selectedPropietario: any;
  selectedCultivo:any;
  selectedMunicipio: any;
  selectedFeature: Feature<Geometry>;;
  selectAction: Select;
  vUser = "";
  vGroupUsers = [];

  constructor(protected sigpacService: SigpacServiceService,
    protected visorFirebaseService: VisorFirebaseService,private router: Router,
    private nbToastr: NbToastrService,
    private nbSearch: NbSearchService,
    private mapQuery: MapQueryService) { }

  ngOnInit(): void {
    if (typeof this.config === 'undefined') {

      this.config = {
        target: 'visormap',
        center : [-5.6954768,40.9670626]
      };
    }


    this.visorFirebaseService.getUser().subscribe((user) =>{
      console.log ("TEnemos usuario")
      if (user) {
        console.log(user)
        this.vUser = user.uid;

        this.visorFirebaseService.groupUsers$.subscribe((groupUsers) => {
          this.vGroupUsers = groupUsers;
          console.log("Group Users:", this.vGroupUsers);
        });

        this.visorFirebaseService.obtenerParcelas().subscribe((parcelas) => {
          console.log("Tenemos parcelas")
          this.parcelas = parcelas;
          this.originalParcelas = parcelas;
          this.pintarParcelasEnMapa();
          this.calcularMunicipios();
          this.calcularCultivos();
        });

        this.cargarTemporadas();

      }else{
        this.parcelas = null;
        if (typeof this.parcelasSource !== 'undefined'){
          this.parcelasSource.clear();
        }

      }

    });

    this.nbSearch.onSearchSubmit().subscribe((busqueda)=>{
      console.log("Buscamos la localidad ");
      console.log(busqueda)
      this.buscarLocalidad(busqueda.term);
    })
  }

  getGroupUserEmail(userOwnerId: string): string {
    const groupUser = this.vGroupUsers?.find(user => user.id === userOwnerId);
    return groupUser ? groupUser.email : '';
  }
  
  calcularMunicipios() {
      this.municipios = Array.from(new Set( this.parcelas.map( p => p.municipio)));
  }

  calcularCultivos() {
    this.cultivos = Array.from(new Set(this.parcelas.filter(p => p.campania != undefined && p.campania != null).map(p => {
        return {codCultivo : p.campania.codCultivo, cultivo: p.campania.cultivo};

    }))).reduce((unique, item) => {
      if (!unique.find(obj => obj.codCultivo === item.codCultivo)) {
          unique.push(item);
      }
      return unique;
  }, []);
    console.log(this.cultivos);
  }
  pintarParcelasEnMapa() {
    this.parcelas.forEach((field) => {



      if(field.geometry != null) {

        console.log(field.geometry);
        field.geometry.coordinates[0] = field.geometry.coordinates[0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })

        let feature = new Feature({
          geometry: new Polygon(
            field.geometry.coordinates),

          parcela: field,
        });

        console.log(feature);
        feature.setStyle(this.parcelaStyle.clone());
        if (typeof field.color != 'undefined'){
          (feature.getStyle() as Style).getFill().setColor(field.color);
        }

        this.parcelasSource.addFeature(feature);

      }




    });


    this.map.getView().fit(this.parcelasSource.getExtent(),{padding:[100,100,100,100],nearest:true});
  }

  ngAfterViewInit(): void {
    this.initMap();

  }

  initMap() {
    this.vectorSource = new VectorSource();
    this.parcelasSource = new VectorSource();

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    var ptl = new VectorLayer({
      source: this.parcelasSource,
    });
    this.vtl = new VectorTileLayer({
      properties:{
      visible: true,
      title: 'Parcelario SIGPAC',

      type:'feature',
      },
      minZoom:15,
      style: new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 2,
        }),
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0)',
        }),
      }),
      source: new VectorTileSource({
                                    maxZoom:15,

                                    format: new GeoJSON(),
                                    //http://sigpac.mapama.gob.es/vectorsdg/vector/recinto@3857/15.15866.20485.geojson
                                    url:'https://us-central1-visorsigpac-57282.cloudfunctions.net/cors?url=https://sigpac.mapama.gob.es/vectorsdg/vector/recinto@3857/{z}.{x}.{-y}.geojson',

                                   // matrixSet: 'EPSG:4326',
                                  }),

    });

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer(<BaseLayerOptions>{
          source: new OSM(),
          visible:false,
          title: 'Mapa Base',
          type:'base',
        }) ,
        new TileLayer(<BaseLayerOptions>{
          visible: true,
          title: 'Mapa PNOA',
          type:'base',
          source: new WMTS({
            attributions: ['Teselas de PNOA cedido por el Instituto Geográfico Nacional de España'],
            url: 'http://www.ign.es/wmts/pnoa-ma',
            layer: 'OI.OrthoimageCoverage',
            // matrixSet: 'EPSG:4326',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: olProj.get('EPSG:3857'),

            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds
            }),
            style: 'default',
          })
        }),
        new TileLayer({
          visible: false,
          properties:{title: 'Mapa Geográfico',type:'base'},

          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        this.vtl,
        ptl,
      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 8,
      })
    });

    var layerSwitcher = new LayerSwitcher();
    this.map.addControl(layerSwitcher);


    this.map.on(['moveend'], (event) => {
      console.log(this.map.getView().getZoom());
      if(this.map.getView().getZoom()<16){
        console.log("Acercate para ver las parcelas");
        this.nbToastr.warning('Aumente el zoom para visualizar las parcelas SIGPAC','Parcelas SIGPAC',{preventDuplicates:true})
      }
    });

    this.selectAction = new Select({style:this.selectedParcelaStyle});

    this.selectAction.on('select',(event) => {
      console.log("SELECCIONADA")
      console.log((event.target as any).getFeatures().item(0).getProperties());
      (event.target as any).getFeatures().item(0).setStyle(this.selectedParcelaStyle)
      (event.target as any).getFeatures().item(0).changed();
    });

   // this.map.addInteraction(this.selectAction);



    this.map.on(['click'],  (event) => {
      console.log("Obteniendo propiedades")
      this.loading = true;
      ptl.getFeatures((event as any).pixel).then( parcelasFeatures => {
        if(parcelasFeatures.length > 0){
          console.log(parcelasFeatures[0].getProperties());
          let parcid = parcelasFeatures[0].getProperties().parcela.id
          this.sigpacService.getParcelaDetail(parcelasFeatures[0].getProperties().parcela).subscribe((datos) => {
            this.parcelasigpac = {...parcelasFeatures[0].getProperties().parcela, ...datos}; ;
            this.parcelasigpac.newAlias = this.parcelasigpac.alias;

            if(this.parcelasigpac.campania == null) this.parcelasigpac.campania = {};
            this.parcelasigpac.id = parcid;
            this.loading = false;
          },(error) => {
            this.nbToastr.warning('No se ha podido obtener info SIGPAC de la web del Ministerio. Sólo se mostrará la información almacenada en los registros de la aplicación','Información incompleta');

            this.parcelasigpac = parcelasFeatures[0].getProperties().parcela;
            this.parcelasigpac.parcelaInfo = JSON.parse(JSON.stringify(this.parcelasigpac));
            this.parcelasigpac.query = [];
            this.parcelasigpac.id = parcid;

            console.log(this.parcelasigpac);
            this.loading = false;
          });

        }else{
          if(this.selectedFeature != null){
            this.selectedFeature.setStyle();
          }

          try{
            this.vtl.getFeatures((event as any).pixel).then (features => {
              if(features.length > 0){
                console.log(features[0].getProperties());
                this.selectedFeature = features[0];
                this.selectedFeature.setStyle(this.selectedParcelaStyle)
                this.selectedFeature.changed();
                this.vtl.changed();
                this.sigpacService.getParcelaDetail(features[0].getProperties()).subscribe((datos) => {
                  this.parcelasigpac = datos;
                  this.loading = false;
                });
              }else{
                this.loading = false;
                this.nbToastr.warning('La selección no corresponde a ninguna parcela SIGPAC','Parcela no encontrada',{preventDuplicates:true});
              }



            });
          }catch(e){
            this.loading = false;
            this.nbToastr.warning('La selección no corresponde a ninguna parcela SIGPAC','Parcela no encontrada',{preventDuplicates:true});
          }



        }
      })

    });

  }

  closeParcelaInfo(){
      this.parcelasigpac = null;
      if(this.selectedFeature != null){
        this.selectedFeature.setStyle();
        this.selectedFeature.changed();
        this.vtl.changed();
      }

  }



  gotoDiario(fieldId: string){
    console.log("Diario")
    console.log(fieldId)
    this.router.navigate(['pages','diario',fieldId]);
  }

  buscarLocalidad(localidad: string): void{

    this.loading = true;
    console.log("Buscamos la localdiad")
    this.mapQuery.queryLocationByAddress(localidad+", España").then((locat)=>{
      console.log(locat);
      this.loading = false;
      this.map.setView(new View({
        center: olProj.fromLonLat([locat.lng,locat.lat]),
        zoom: 16,
      }));
    });
  }

  mostrarParcela(fieldId: string){


    this.selectedFeature = this.parcelasSource.getFeatures().find(f => f.get('parcela').id == fieldId);

      this.selectedFeature.get('parcela').newAlias = this.selectedFeature.get('parcela').alias;

      if(this.selectedFeature.get('parcela').campania == null) this.selectedFeature.get('parcela').campania = {};

      console.log(this.selectedFeature);
       this.map.getView().fit(this.selectedFeature.getGeometry().getExtent(),{padding:[200,200,200,200],nearest:true});

       //La seleccionamos
       let parcid = this.selectedFeature.getProperties().parcela.id
          this.sigpacService.getParcelaDetail(this.selectedFeature.getProperties().parcela).subscribe((datos) => {
            this.parcelasigpac = {...this.selectedFeature.getProperties().parcela, ...datos}; ;
            this.parcelasigpac.id = parcid;
            this.loading = false;
          },(error) => {
            this.nbToastr.warning('No se ha podido obtener info SIGPAC de la web del Ministerio. Sólo se mostrará la información almacenada en los registros de la aplicación','Información incompleta');

            this.parcelasigpac = this.selectedFeature.getProperties().parcela;
            this.parcelasigpac.parcelaInfo = JSON.parse(JSON.stringify(this.parcelasigpac));
            this.parcelasigpac.query = [];
            this.parcelasigpac.id = parcid;

            console.log(this.parcelasigpac);
            this.loading = false;
          });
    console.log(this.selectedFeature);
  }

  guardarParcela(parcela:any){

    let p: any = {campania:{}};
    p.id = parcela.id;
    p.alias = parcela.newAlias;
   p.campania.campaniaRef = parcela.campania.campaniaRef;
    p.campania.codCultivo = parcela.campania.codCultivo;
    p.campania.campania = this.seasons.find(s => s.identifier === parcela.campania.campaniaRef).name;
    p.campania.cultivo = this.productos.find(pr => pr.identifier == parcela.campania.codCultivo).name;
    console.log(p);
    this.visorFirebaseService.updateParcela(p).subscribe((confirmado) => {
      console.log("Actualizado")
      let index = this.parcelas.indexOf(this.parcelas.find(pr => pr.id === parcela.id));
      console.log(index);
      this.parcelas[index].alias = p.alias;
      this.parcelas[index].campania = p.campania;
      console.log(this.parcelas);
    });

}

cargarTemporadas(){
  this.visorFirebaseService.obtenerSeasons().subscribe(seasons => this.seasons = seasons);
}

updateParcelasFilter(){

  this.parcelas = this.originalParcelas.filter( p => {
      let cultivosFilter = false;
      let municipiosFilter = false;
      let propietariosFilter = false;

      if(this.selectedCultivo != undefined && this.selectedCultivo != null && this.selectedCultivo.length > 0){
        if (p.campania != undefined && p.campania != null){
          cultivosFilter = this.selectedCultivo.find(c => c === p.campania.codCultivo)
        }
      } else {
        cultivosFilter = true;
      }

      if(this.selectedMunicipio != undefined && this.selectedMunicipio != null && this.selectedMunicipio.length > 0){
        municipiosFilter = this.selectedMunicipio.find(c => c === p.municipio);

      } else {
        municipiosFilter = true;
      }

      if(this.selectedPropietario != undefined && this.selectedPropietario != null && this.selectedPropietario.length > 0){
        propietariosFilter = this.selectedPropietario.find(c => c === p.userOwner);

      } else {
        propietariosFilter = true;
      }
      return cultivosFilter && municipiosFilter && propietariosFilter;
  });

}

resetParcelasFilter(){

}

}
